import { render, staticRenderFns } from "./NoticeOrderDahuo.vue?vue&type=template&id=52e33df7&scoped=true&"
import script from "./NoticeOrderDahuo.vue?vue&type=script&lang=js&"
export * from "./NoticeOrderDahuo.vue?vue&type=script&lang=js&"
import style0 from "./NoticeOrderDahuo.vue?vue&type=style&index=0&id=52e33df7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e33df7",
  null
  
)

export default component.exports